<template>
  <div>
    <h4>Would you like to receive a quote?</h4>
    <p>
      Maybe number of guests or number of nights you want to travel, don't
      match with our standard packages. Don't worry, you can fill the next
      form to request a quote according to your needs.
    </p>
    <p>
      Please enter your information and one of our reservations specialists
      will contact you by phone or email to bring you a customized quote.
    </p>
    <form class="row g-3 needs-validation" novalidate method="post" id="quoteRequest" @submit="saveRequest">
      <div class="col-md-6">
        <label for="inputEmail4" class="form-label">Name</label>
        <input type="text" class="form-control" v-model="form.firstName" required>
        <span class="form-text invalid-feedback">Please provide your first name</span>
      </div>
      <div class="col-md-6">
        <label for="inputPassword4" class="form-label">Last Name</label>
        <input type="text" class="form-control" v-model="form.lastName" required>
        <span class="form-text invalid-feedback">Please provide your Last Name</span>
      </div>
      <div class="col-md-6">
        <label for="inputPassword4" class="form-label">Email</label>
        <input type="email" class="form-control" v-model="form.email" required>
        <span class="form-text invalid-feedback">Please provide your Email</span>
      </div>
      <div class="col-md-6">
        <label for="inputPassword4" class="form-label" maxlength="10">Phone Number</label>
        <input type="text" class="form-control" maxlength="10" v-model="form.phone" pattern="^\d{10}$" required>
        <span class="form-text invalid-feedback">Please provide a valid Phone Number</span>
      </div>
      <div class="col-md-6">
        <label for="inputPassword4" class="form-label" maxlength="10">Time to be reached</label>
        <input type="text" class="form-control" v-model="form.timeToReach" required>
        <span class="form-text invalid-feedback">Please provide this information</span>
      </div>
      <div class="col-md-6">
        <label for="inputPassword4" class="form-label" maxlength="10">Destination</label>
        <select class="form-select" aria-label="Default select example" v-model="form.destination">
          <option selected></option>
          <option v-for="destination in destinations" :key="destination.name" :value="destination.name">{{
            destination.name }}</option>
        </select>
      </div>
      <div class="col-md-6">
        <label for="inputPassword4" class="form-label" maxlength="10">Arrival Date</label>
        <input type="date" class="form-control" v-model="form.arrivalDate" required>
        <span class="form-text invalid-feedback">Please provide your Arrival Date</span>
      </div>
      <div class="col-md-6">
        <label for="inputPassword4" class="form-label" maxlength="10">Departure Date</label>
        <input type="date" class="form-control" v-model="form.departureDate" required>
        <span class="form-text invalid-feedback">Please provide your Departure Date</span>
      </div>
      <div class="col-md-6">
        <label for="inputPassword4" class="form-label" maxlength="10">Number of Adults</label>
        <input type="number" class="form-control" v-model="form.adultsNumber" required>
        <span class="form-text invalid-feedback">Please provide your Number of Adults</span>
      </div>
      <div class="col-md-6">
        <label for="inputPassword4" class="form-label" maxlength="10">Number of Children</label>
        <input type="number" class="form-control" v-model="form.childrenNumber" required>
        <span class="form-text invalid-feedback">Please provide your Number of Children</span>
      </div>
      <div class="col-md-12">
        <label class="form-label">Comments</label>
        <textarea class="form-control" rows="2" v-model="form.comments"></textarea>
      </div>
      <div class="col-12">
        <button type="submit" class="btn btn-green w-100">Sign in</button>
      </div>
    </form>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import store from "@/store.js";

export default {
  data() {
    return {
      form: this.initialValues(),
      saved: false,
      waiting: false,
      childrenAges: [],
      destinations: store.destinations.filter(d => d.visible !== false),
    };
  },
  watch: {
    "form.children": function (newVal) {
      this.childrenAges = [];
      for (let i = 0; i < newVal; i++) {
        this.childrenAges.push({
          childrenIndex: i,
          age: null,
        });
      }
    },
  },
  methods: {
    saveRequest(e) {
      let form = e.target;
      if (form.checkValidity() === true) {
        this.waiting = true;
        this.loadingMessage()
        var url =
          "https://hooks.zapier.com/hooks/catch/4763102/3nqnlox/";
        var data = this.form;
        data.notes = "";
        data.notes += `Adults: ${this.form.adultsNumber}<br>`;
        data.notes += `Children: ${this.form.childrenNumber}<br>`;
        data.notes += "Children Ages: ";

        this.childrenAges.forEach((child) => {
          data.notes += child.childrenIndex + 1 + ": " + child.age + ", ";
        });

        data.notes += `<br>Comments: ${this.form.comments}`;
        fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          // headers: {
          //   "Content-Type": "application/json",
          // },
        })
          .then(() => {
            // let myModal = document.getElementById('requestForm')
            this.closeModal()
            // myModal.hidden()
            this.successMessage();
            this.triggerGTM();
            this.resetValues();
            this.waiting = false;
            this.saved = true;
            window.gtag_report_conversion_qr();
          })
          .catch(() => {
            this.waiting = false;
            this.errorMessage()
          });
      }
      form.classList.add("was-validated");
      e.preventDefault();
    },
    // validEmail(email) {
    //   var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return re.test(email);
    // },
    triggerGTM() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'form_success', 'formname': 'request_quote', 'corporate': 'tafer' });
    },
    loadingMessage() {
      this.loading = Swal.mixin({
        customClass: {
          loader: 'spinner',
        }
      })
      return this.loading.fire({
        text: "Submitting",
        showConfirmButton: false,
        iconColor: "##0B6482",
        backdrop: `rgba(0,0,0,0.5)`,
        width: 160,
        timerProgressBar: true,
        // timer: 3000,
        didOpen: () => {
          this.loading.showLoading();
        },
      });
    },
    successMessage() {
      this.tab = 3
      return Swal.fire({
        icon: "success",
        title: "Thanks, all set.",
        text: "An agent will be in touch with you soon.",
        color: "#0B6482",
        showConfirmButton: false,
        timer: 5000,
        iconColor: "#0B6482",
        backdrop: `rgba(0,0,0,0.5)`,
        customClass: {
          title: 'sweetAlerTitle',
          icon: 'successIcon',
        }
      });
    },
    errorMessage() {
      return Swal.fire({
        icon: "warning",
        title: "Oops",
        text: "An unexpected error ocurred, please try again.",
        color: "#0B6482",
        iconColor: "#ffd700",
        showConfirmButton: false,
        // timer: 5000,
        backdrop: `rgba(0,0,0,0.5)`,
      });
    },
    closeModal() {
      let bannerModal = document.querySelector('#requestForm');
      //eslint-disable-next-line
      const bannerModalInstance = new bootstrap.Modal(bannerModal);
      bannerModalInstance.dispose();
    },
    resetValues() {
      this.form = this.initialValues();
      document.getElementById("quoteRequest").classList.remove("was-validated");
    },
    initialValues() {
      return {
        webhookID: "802b658b-8864-c39a-ac0a-9736aec41801",
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        timeToReach: null,
        destination: null,
        arrivalDate: null,
        departureDate: null,
        adultsNumber: null,
        childrenNumber: null,
        childrenAges: [],
        comments: null,
        notes: null,
        leadTypeID: 2,
        leadSourceChannelID:  localStorage.getItem('utm_medium'),
        leadSourceID: localStorage.getItem('utm_source'),
        campaignName: localStorage.getItem('utm_campaign'),
      };
    },
  },
  mounted() {
    // this.showBanner();

  },
};
</script>

<style></style>